/* src/sb-tools/typescript/components/sidenav/sidenav.component.scss */
:host {
  position: absolute;
  overflow: auto;
  background-color: #353a3f;
  color: white;
  height: 100%;
  width: 100%;
  min-width: 240px;
  z-index: 10;
  transition: transform 0.4s cubic-bezier(0, 0, 0.3, 1);
}
:host.is-expanded {
  transform: translateX(-100%);
}
/*# sourceMappingURL=sidenav.component.css.map */
